export const STEPPER            = "stepper";
export const TABS               = "tabs";
export const FORM               = "form";
export const CARD               = "card";
export const COMPONENT          = "component";
export const MEDIAPICKER        = "mediapicker";